import Cosmetology from "../images/cosmetology.jpg";
import Makeup from "../images/makeup.jpg";
import Hair from "../images/hair.jpg";
import skin from "../images/skin.jpg";
import nailArt from "../images/nail-art.jpg";
import Manicure from "../images/manicure-pedicure.jpg";
import "../css/animate.css"
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import lock from "../images/lock.png";
import { Component } from "react";
import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { editorState, convertToRaw, ContentState, convertFromHTML, Modifier, EditorState } from 'draft-js';
import { saveItCareerForm } from "../service";
import draftToHtml from "draftjs-to-html";
import Parser from "html-react-parser";
import AWS from "aws-sdk";
import { getawscredentials } from "../service";
var s3;
const editorTools = {
  options: ["inline", "link", "list"],
  inline: {
    options: ["bold", "italic", "underline", "superscript", "subscript"],
  },
  link: {
    options: ["link"],
  },
  list: {
    options: ["unordered", "ordered"],
  },
};
class Course extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditorCourseListActive: "0",
      serviceArray: [],
      ["editorState_service"]: "",
      serviceArrayList: [],
      serviceTitleState: "",
      serviceDescriptionState: "",
      serviceChooseTextState: "",
      imageFullFilePath: "",
      file: "",
      imageFileName: "",
      serviceImage: "",
      s3BucketMainFolder: "",
      accessKey: "",
      secretKey: "",
      s3bucket: "",
      courseListAddArray: [],
      courseListEditArray:[],
      courses: "",
      courseListAdd: [],
      serviceCourseTextState: [],
      serviceaddcourseState: [],
      selectedFile:""
    }
  }


  componentDidMount() {
    this.getAwsDetails();
    this.setState({
      serviceContentId: this.props.serviceArray[0].contentDataId,
      serviceArrayList: this.props.serviceArray[0].listing,
    });
    if (this.props.serviceArray[0].listing.length > 0) {
      console.log("serviceArray[0].listing[0].contentDataSubDescription", this.props.serviceArray[0].listing[0].contentDataSubDescription);
      this.setState({
        serviceTitleState: this.props.serviceArray[0].listing[0].contentDataSubTitle,
        serviceDescriptionState: this.props.serviceArray[0].listing[0].contentDataSubSubtitle,
        serviceChooseTextState: this.props.serviceArray[0].listing[0].h3Tag,
        serviceaddcourseState: this.props.serviceArray[0].listing[0].contentDataSubDescription
      })
    }
  }
  getAwsDetails() {
    // new Promise((resolve, reject) => {
    let postData = {
      "functionName": "awsCredentials",
    };
    getawscredentials(postData).then((data) => {
      console.log("decoded", data);
      if (data.data.success === "1") {
        var decoded = data.data.result.s3Details;
        localStorage.setItem("S3BucketMainFolder", decoded.mainFolder);
        localStorage.setItem("Bucket", decoded.s3bucket);

        AWS.config.update({
          accessKeyId: decoded.accessKey,
          secretAccessKey: decoded.secretKey,
          region: "ap-south-1",
        });
        var bucketParams = {
          Bucket: decoded.s3bucket,
        };
        s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });

        this.setState(
          {
            s3BucketMainFolder: decoded.mainFolder,
            accessKey: decoded.accessKey,
            secretKey: decoded.secretKey,
            s3bucket: decoded.s3bucket,
          },
          () => {
            // resolve(true);
          }
        );
      } else {
        console.log("error:home:getAwsDetails:", data.errorMessage);
      }
    });
    // });
  }
  onEditorStateChange = (e, mode) => {
    this.setState({
      [mode]: e,
    });
  };
  handleBeforeInput = (e, mode) => {
    const currentContent = this.state[mode].getCurrentContent();
    const currentContentLength = currentContent.getPlainText("").length;
    if (currentContentLength >= 2500) {
      return "handled";
    }
  };
  Editsave(mode, data, i) {
    let contentDataId = this.state.serviceContentId
    let serviceTitle = $("#editServiceinput" + i).val();
    let serviceAlt = $("#editserviceAltinput" + i).val();
    let serviceDescription = draftToHtml(
      convertToRaw(this.state["editorState_serviceEdit"].getCurrentContent())
    );
    let serviceChooseText = $("#editservice_inputxt" + i).val();;
    let imageName =
      this.state.imageFileName !== ""
        ? this.state.imageFileName
        : data.imageName


    var oldcourseValue = this.state.courseListEditArray;
    if(this.state.courseListEditArray.length<2){
    if (
      $("#editcourseInputtxt"+i).val() !== ""
    ) {
      var courseListinput = { courses: $("#editcourseInputtxt"+i).val() }
      oldcourseValue.push(courseListinput);
      this.setState({
        courseListEditArray: oldcourseValue,
      });
      $("#editcourseInputtxt" + i).val("");
    }
  }
    var courseListinput = {
      courseListinput: this.state.courseListEditArray,
    };
    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      contentDataSubId: data.contentDataSubId ,
      contentDataSubDescription: JSON.stringify(this.state.courseListEditArray),
      contentDataSubTitle: serviceTitle,
      siteId: "",
      contentDataSubIsApproved: "0",
      image: imageName,
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
      altText: serviceAlt,
      h3Tag: serviceChooseText,
      contentDataSubSubtitle: serviceDescription,
    };
    if (this.state.imageFileName.length > 0) {
      this.saveImageUpload();
    }
    { console.log("service editpost data = ", postData); }
    saveItCareerForm(postData).then((data) => {
      if (data.data.success == 1) {
        this.props.getData()
        this.cancelServiceList();
        this.cancelCourseLists(i);
      

      }
    })

  }

  save(data, i) {
    var flag = true
    var mode = mode;
    var flag = true;
    let serviceTitle = "";
    let serviceAlt =""
    let serviceDescription = "";
    let serviceChooseText = "";
    let servicecourseText = "";
    let imageName = "";

    if ($("#txtserviceTitle").val() === '') {
      alert("Enter Text")
      return false
    }
    if (!this.state["editorState_service"]) {
      alert("Enter Description")
      return false
    }
    if (!this.state.imageFileName) {
      alert("Upload Image")
      return false
    }

    if (flag == true) {
      let contentDataId = this.state.serviceContentId

      // if (mode === "Add") {
      console.log("serviceDescription==", serviceDescription);
      serviceTitle = $("#txtserviceTitle").val();
      serviceAlt = $("#courseadd_altinput").val();
      serviceDescription = draftToHtml(
        convertToRaw(this.state["editorState_service"].getCurrentContent())
      );
      serviceChooseText = $("#servicetextchoose").val();
      imageName =
        this.state.imageFileName !== ""
          ? this.state.imageFileName
          : "";
      // servicecourseText = this.state.courseListAdd === "" ? [] : this.state.courseListAdd;
      // var newcourseArray = this.state.courseListAddArray;
      var oldcourseValue = this.state.courseListAddArray;
      if(this.state.courseListAddArray.length<2){
      if (
        $("#courseInputtxt").val() !== ""
      ) {
        var courseListinput = { courses: $("#courseInputtxt").val() }
        oldcourseValue.push(courseListinput);
        this.setState({
          courseListAddArray: oldcourseValue,
        });
      }
    }

      // oldcourseValue.push(courseListinput);
      // }
      // else {
      //   serviceTitle = $("#editServiceinput" + i).val();
      //   serviceDescription = draftToHtml(
      //     convertToRaw(this.state["editorState_serviceEdit"].getCurrentContent())
      //   );
      //   serviceChooseText = $("#editservice_inputxt" + i).val();
      //   imageName =
      //     this.state.imageFileName !== ""
      //       ? this.state.imageFileName
      //       : data.imageName
      // }

      this.saveservice(
        serviceTitle,
        serviceAlt,
        serviceDescription,
        contentDataId,
        serviceChooseText,
        servicecourseText,
        imageName,
        mode,
        data,
        i,
      );
    }

  }
  saveservice(
    serviceTitle,
    serviceAlt,
    serviceDescription,
    contentDataId,
    serviceChooseText,
    servicecourseText,
    imageName,
    mode,
    data,
    i,
  ) {
    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      contentDataSubId: "",
      contentDataSubDescription: JSON.stringify(this.state.courseListAddArray),
      contentDataSubTitle: serviceTitle,
      siteId: "",
      contentDataSubIsApproved: "0",
      image: imageName,
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
      altText: serviceAlt,
      h3Tag: serviceChooseText,
      contentDataSubSubtitle: serviceDescription,
    };
    if (this.state.imageFileName.length > 0) {
      this.saveImageUpload();
    }
    { console.log("service post data = ", postData); }
    saveItCareerForm(postData).then((data) => {
      if (data.data.success == 1) {
        $("#txtserviceTitle").val("");
        $("#courseadd_altinput").val("");
        $("#servicetextchoose").val("");
        $("#courseInputtxt").val("");
        $("#addcoursetextinput").val("");
        this.setState({
          ["editorState_service"]: EditorState.createWithContent(
            ContentState.createFromBlockArray(convertFromHTML(""))
          ),
          courseListAddArray: [],
          serviceImage:"",
          imageFileName:"",
        });
        this.cancelServiceList();
        this.cancelCourseLists(i);
        this.props.getData()

      }
    })
  }

  editServiceSec(data, i) {
    console.log("editdata == ", data);
    console.log("editdata1 == ", data.contentDataSubSubtitle);
    console.log("editdata2 == ", data.contentDataSubTitle);
    $("#firstPart" + i).addClass("editActive");
    // this.setState({ isEditorCourseListActive: "1" });
    this.setState({
      ["isEditorCourseListActive" + i]: "1",
      serviceImage : "",
    });
    // if (data.length > 0) {
    this.setState({
      ["editorState_serviceEdit"]: EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(data.contentDataSubSubtitle)
        )
      ),
      courseListEditArray: JSON.parse(data.contentDataSubDescription)
    });
    $("#editServiceinput" + i).val(data.contentDataSubTitle);
    $("#editservice_inputxt" + i).val(data.h3Tag);
    
  }


  // }
  serviceImageupLoad(e) {
    // e.preventDefault();
    // if (e.target.files[0].size > 2097152) {
    //   // 2 MiB for bytes.
    //   alert("File size must be below 2MB!");
    //   return;
    // }

    var fileObj = e.target.files[0];
    let str = fileObj.name;
    var last = str.substring(str.lastIndexOf("/") + 1, str.length);
    let S3BucketMainFolder =
      localStorage.getItem("S3BucketMainFolder");
    let fileName = "aic_" + last;
    let reader = new File([fileObj], fileName, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
    let fullFilePath = S3BucketMainFolder + "/" + fileName;
    this.setState({
      imageFullFilePath: fullFilePath,
      file: reader,
      imageFileName: fileName,
      serviceImage: window.URL.createObjectURL(e.target.files[0]),
    });
  }
  saveImageUpload() {
    s3.upload(
      {
        Key: this.state.imageFullFilePath,
        Body: this.state.file,
        ACL: "public-read",
      },
      (err, data) => {
        console.log("err", err);
        if (err) {
          alert("There was an error uploading your photo: ", err.message);
          return null;
        } else {
        }
      }
    );
  }

  deleteService(mode, data) {
    if (mode === "delete") {
      const postData = {
        functionName: "delete",
        contentDataSubId: data.contentDataSubId,
      };
      if (window.confirm("Do you want to delete?")) {
        saveItCareerForm(postData).then((data) => {
          if (data.data.success == 1) {
            this.props.getData();
            window.location.reload();
          }
        });
      } else {
        return false;
      }
    }
  }

  addRowcourses(e, mode,i) {
    var oldcourseValue = this.state.courseListAddArray;
    var oldcourseValue1 = this.state.courseListEditArray;
    var flag = true;
    if (mode === "add") {
      if ($("#courseInputtxt").val() === "") {
        alert("Enter Text")
        $("#courseInputtxt").focus();
        flag = false;
      }
      if (flag === true) {
        var courseinputValue = {
          courses: $("#courseInputtxt").val()
        }
        oldcourseValue.push(courseinputValue);
        this.setState({
          courseListAddArray: oldcourseValue,
        });
        $("#courseInputtxt").val("");
      }
    }
    else{
      if ($("#editcourseInputtxt" + i).val() === "") {
        alert("Enter Text")
        $("#editcourseInputtxt" + i).focus();
        flag = false;
      }
      if (flag === true) {
        var courseinputValue = {
          courses: $("#editcourseInputtxt" + i).val()
        }
        oldcourseValue1.push(courseinputValue);
        this.setState({
          courseListEditArray: oldcourseValue1,
        });
        $("#editcourseInputtxt" + i).val("");
      }
    }
  }

  addRowCourseDelete(mode,i) {
    let courseItemremoved
    if(mode==="add"){
    courseItemremoved = this.state.courseListAddArray;}
    else{
    courseItemremoved = this.state.courseListEditArray;
    }
    courseItemremoved.splice(i, 1);
    this.setState({
      courseListAddArray: courseItemremoved,
    });
  }
  // editEditButton(index,data){
  //   let tempArray = JSON.parse(data.contentDataSubDescription);
  //   tempArray[0].courses = $("#editcoursetextinput" + index).val();
  //   this.setState({
  //     courseListAddArray: tempArray,
  //   });
  // }

  editEditButton(mode, index,data, i) {
    let temp = [...this.state.courseListEditArray]
    temp[index].courses = $("#" + mode + i+index).val();
    this.setState({
      courseListEditArray: temp,
    });
  }

  AddCourseWrapper() {
    $(".addrowcourse").remove();
    $(".addSection").addClass("editActive");
    //this.setState({isEditorCourseActive:"1"});
  }
  cancelServiceList() {
    $(".addSection").removeClass("editActive");
    //.setState({isEditorCourseActive:"0"});
  }
  // editCourseList() {

  //   $(".panel").addClass("editActive");
  //   this.setState({ isEditorCourseListActive: "1" });

  // }
  cancelCourseLists(i) {
    $("#firstPart" + i).removeClass("editActive");
    // this.setState({ isEditorCourseListActive: "0" });
    this.setState({
      ["isEditorCourseListActive" + i]: "0",
    });
  }

  render() {

    return (
      <section className="padding courseListWrapper">
        <div className="container-fluid">
          {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
            <div className="adminIconMain">
              <span
                className="editIcon addButton"
                onClick={(e) => {
                  this.AddCourseWrapper();
                }}
              >
                <img src={Add} />
              </span>
            </div>
          }

          <div
            className="panel-group"
            id="accordion"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="addSection">
              <div class="text-center mb-2">
                <span class="upload-label-txt">jpeg/png less than 1 MB and 415*340px</span>
                <span class="fileUpload">
                  <input class="fileUploadCourse" type="file" id="fileUploadCourseMaster1" onChange={(e) => this.serviceImageupLoad(e)} />
                  <label for="fileUploadCourseMaster1">Upload media</label>
                </span>
              </div>
              {this.state.serviceImage ? 
              <div className="text-center mb-3">
                <img src={this.state.serviceImage} style={{width:"60%", height:"135px"}} />
              </div>
              : "" }
              <input type="text" className="editInput" id="courseadd_altinput"  placeholder="Enter alt Text" />
              <input type="text" placeholder="Enter Title" autocomplete="off" class="editInput" id="txtserviceTitle" />
              <Editor
                editorState={this.state["editorState_service"]}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                className="editTextInput"
                editorClassName="editorClassName"
                onEditorStateChange={(e) =>
                  this.onEditorStateChange(e, "editorState_service")
                }
                handleBeforeInput={(e) =>
                  this.handleBeforeInput(e, "editorState_service")
                }
                handlePastedText={(input) => {
                  const inputLength = this.state["editorState_service"]
                    .getCurrentContent()
                    .getPlainText().length;
                  let remainingLength = 2500 - inputLength;
                  if (input.length + inputLength > 2500) {
                    const newContent = Modifier.replaceText(
                      this.state["editorState_service"].getCurrentContent(),
                      this.state["editorState_service"].getSelection(),
                      input.slice(0, remainingLength)
                    );
                    this.onEditorStateChange(
                      EditorState.push(
                        this.state["editorState_service"],
                        newContent,
                        "insert-characters"
                      ),
                      "editorState_service"
                    );
                    return true;
                  } else {
                    return false;
                  }
                }}
                toolbar={{
                  editorTools,
                }}
              />
              <input type="text" placeholder="Enter Title" autocomplete="off" class="editInput" id="servicetextchoose" />
              {this.state.courseListAddArray.length<2 &&(
                <>
              <div className="rowAdd">
                <input type="text" placeholder="Enter Course " class="editInput" id="courseInputtxt" />
                <img src={Add} alt="Add" className="imgrowAdd"
                  onClick={(e) => {
                    this.addRowcourses("", "add","");
                  }}
                />
              </div>
              </>)}
              {console.log(this.state.courseListAddArray,"dddddddddddddddddddddddd**")}
              
              {this.state.courseListAddArray.map((Obj, i) => (
                <div className="rowAdd addrowcourse">
                  <input placeholder="Enter Course " class="editInput" id="addcoursetextinput"
                    value={Obj.courses} disabled
                  />
                  <img src={Delete} alt="Delete" className="imgrowAdd"
                    onClick={(e) => {
                      this.addRowCourseDelete("add",i);
                    }}
                  />
                </div>
              ))}
              
              <div class="editPanelButton">
                <span class="saveButton" onClick={() => { this.save() }}>Save</span>
                <span class="cancelButton" onClick={(e) => { this.cancelServiceList() }}>Cancel</span>
              </div>

            </div>
            {this.props.serviceArray[0].listing.map((data, i) => (
              <div
                className={
                  "panel panel-default wow fadeIn " + (i % 2 == 0 ? "leftPanel" : " rightPanel")
                }
                id={"firstPart" + i}
              // className="panel panel-default wow fadeIn leftPanel rightPanel "
              >
                {/* {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
                  <div className="adminIconLeft">
                    <div className="approveButton">Approve</div>
                    <div class="draftSpan"> Draft </div>
                    <div className="rejectSection">
                      <div class="rejectButton"> Reject </div>
                      <textarea
                        className="rejectComment"
                        placeholder="Enter Reason"
                      ></textarea>
                    </div>
                    <div className="rejectSection">
                      <div class="rejectButton"> Rejected </div>
                      <div className="rejectCommentText">Reason :</div>
                    </div>
                  </div>
                } */}

                {console.log("serviceArrayList== ", this.state.serviceArrayList)}

                <div className="courseImage">
                  <div className="img">
                    <img
                      src={data.image}
                      alt={data.altText}
                      title={data.altText}
                    />
                    <div class="imageEditList">
                      <span class="upload-label-txt">jpeg/png less than 1 MB and 546*448</span>
                      <span class="fileUpload">
                        <input class="fileUploadCourse" type="file" id="fileUploadwhoweare" onChange={(e) => this.serviceImageupLoad(e)} />
                        <label for="fileUploadwhoweare">Upload media</label>
                      </span>
                      {console.log("this.state.serviceImage", data.image)}
                      {this.state.serviceImage ?
                        <div className="text-center mb-3">
                          <img src={this.state.serviceImage} style={{ width: "60%", height: "135px" }} />
                        </div>
                        : 
                        <div className="text-center mb-3">
                          <img src={data.image} style={{ width: "60%", height: "135px" }} />
                        </div>}
                        <input type="text" placeholder="Enter alt Title" class="editInput" id={"editserviceAltinput" + i}/>
                    </div>
                  </div>

                </div>
                <div className="panel-heading" role="tab" id="headingOne">
                  {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
                    <div className="adminIconMain">
                      <span
                        class="editIcon editButton"
                        onClick={(e) => {
                          this.editServiceSec(data, i);
                        }}
                      >
                        <img src={Edit} alt="Edit"/>
                      </span>
                      {/* <span class="editIcon lockButton"><img src={lock} /></span> */}
                      <span class="editIcon DeleteIcon" onClick={() => this.deleteService("delete", data)}>
                        <img src={Delete} />
                      </span>
                    </div>
                  }
                  <h4>{data.contentDataSubTitle}</h4>
                  <input type="text" placeholder="Enter Title" class="editInput" id={"editServiceinput" + i} />
                  {console.log("this.state.serviceCourseTextState1112222", this.state.serviceCourseTextState)}
                  <p>{Parser(data.contentDataSubSubtitle)}</p>
                 
                  <p>{data.h3Tag}</p>
                  {console.log("this.state.serviceCourseTextState1111", JSON.parse(data.contentDataSubDescription))}
                  <ul className="list-inline">
                    {JSON.parse(data.contentDataSubDescription).map((test, k) => (

                      // <p>{test.courses}</p>

                      <li>{test.courses}</li>

                    ))}
                  </ul>


                  {/* {test.map((teset, i) => (
                    <ul className="list-inline">
                      <li>{console.log(teset)}</li>
                    </ul>
                  ))} */}
                  {
                    this.state["isEditorCourseListActive" + i] === "1" ?
                      <Editor
                        editorState={this.state["editorState_serviceEdit"]}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        className="editTextInput"
                        editorClassName="editorClassName"
                        onEditorStateChange={(e) =>
                          this.onEditorStateChange(e, "editorState_serviceEdit")
                        }
                        handleBeforeInput={(e) =>
                          this.handleBeforeInput(e, "editorState_serviceEdit")
                        }
                        handlePastedText={(input) => {
                          const inputLength = this.state["editorState_serviceEdit"]
                            .getCurrentContent()
                            .getPlainText().length;
                          let remainingLength = 2500 - inputLength;
                          if (input.length + inputLength > 2500) {
                            const newContent = Modifier.replaceText(
                              this.state["editorState_serviceEdit"].getCurrentContent(),
                              this.state["editorState_serviceEdit"].getSelection(),
                              input.slice(0, remainingLength)
                            );
                            this.onEditorStateChange(
                              EditorState.push(
                                this.state["editorState_serviceEdit"],
                                newContent,
                                "insert-characters"
                              ),
                              "editorState_serviceEdit"
                            );
                            return true;
                          } else {
                            return false;
                          }
                        }}
                        toolbar={{
                          editorTools,
                        }}
                      />
                      : ""
                  }
                  <input type="text" placeholder="Enter Title" autocomplete="off" class="editInput" id={"editservice_inputxt" + i} />
                  {this.state.courseListEditArray.length<2 &&(
                <>
                  <div className="rowAdd">
                    <input type="text" placeholder="Enter Course " class="editInput" id={"editcourseInputtxt" + i} />
                    <img src={Add} alt="Add" className="imgrowAdd"
                      onClick={(e) => {
                        this.addRowcourses("", "edit", i);
                      }}
                    />
                  </div>
                  </>)}
                  {console.log("this.props.serviceArray[0].listing = ", this.props.serviceArray[0].listing)}
                  {/* {this.state.courseListAddArray.map((Obj, i) => ( */}
                  {this.state.courseListEditArray.map((Obj, index) => (
                    <div className="rowAdd">
                       {console.log("this.props.serviceArray[0].listing**** = ",JSON.parse(this.props.serviceArray[0].listing[0].contentDataSubDescription))}
                      <input type="text" placeholder="Enter Course " class="editInput" name={"editcoursetextinput" +i+ index} id={"editcoursetextinput" +i+ index}
                        value={Obj.courses}
                        onChange={(e) =>
                          this.editEditButton("editcoursetextinput", index,Obj, i)
                        }
                      />
                      {/* {console.log("Obj[i].courses =",Obj[i].courses)} */}
                      <img src={Delete} alt="Delete" className="imgrowAdd" 
                        onClick={(e) => {
                          this.addRowCourseDelete("edit",index);
                        }}
                      />
                    </div>
                  ))}
                  <div className="editPanelButton">
                    {/* <span className="saveButton saveDraft">Save Draft</span> */}
                    <span className="saveButton" onClick={() => { this.Editsave("Edit", data, i) }}>Submit</span>
                    <span className="cancelButton" onClick={(e) => { this.cancelCourseLists(i) }}>Cancel</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}
export default Course;
